import { useState } from 'react';
import type { ReportEventDraft, ReportEventDraftEdits } from '@/types/report';

export interface ReportEventDraftsState {
    drafts: ReportEventDraft[];
    selectedEventId: string;
    selectEvent: (eventId: string) => void;
    updateById: (
        eventId: string,
        edits: Partial<ReportEventDraftEdits>,
    ) => void;
    removeById: (eventId: string) => void;
}

export function useReportEventDrafts(
    initialDrafts: ReportEventDraft[],
): ReportEventDraftsState {
    const [drafts, setDrafts] = useState(initialDrafts);
    const [selectedEventId, setSelectedEventId] = useState(
        initialDrafts[0]?.event.id ?? '',
    );

    const updateById = (
        eventId: string,
        edits: Partial<ReportEventDraftEdits>,
    ) =>
        setDrafts((previous) =>
            previous.map((draft) =>
                draft.event.id === eventId ? { ...draft, ...edits } : draft,
            ),
        );

    const removeById = (eventId: string) => {
        const removedIndex = drafts.findIndex(
            (draft) => draft.event.id === eventId,
        );
        const remaining = drafts.filter((draft) => draft.event.id !== eventId);
        setDrafts(remaining);
        if (eventId === selectedEventId) {
            const nextIndex = Math.min(removedIndex, remaining.length - 1);
            setSelectedEventId(remaining[nextIndex]?.event.id ?? '');
        }
    };

    return {
        drafts,
        selectedEventId,
        selectEvent: setSelectedEventId,
        updateById,
        removeById,
    };
}
